import { displayError, displayWarning } from "../../utils/messageToast";
import { SetupNotAuth } from "../../apis/apiNotAuthenticate";
import { SetupFlow } from "../../apis/apisFlowByAuthorizationRA";
import { getSkillId } from "../getSkill";
import { getTabId } from "../getTab";
import { displaySuccess } from "../../utils/messageToast";

export const createForm = async (
  setLoadingButtonCreate: React.Dispatch<React.SetStateAction<boolean>>,
  payload: any,
  setForms: React.Dispatch<React.SetStateAction<string>>,
  authorization: string,
  authorizationRA: string,
  nameForm: string,
  skillIdForm: string,
  tabIdForm: string,
  idForm: string,
  ambient: string,
  setTabName: React.Dispatch<React.SetStateAction<string>>,
  setSkillName: React.Dispatch<React.SetStateAction<string>>,
  setIdForm: React.Dispatch<React.SetStateAction<string>>,
  setNameForm: React.Dispatch<React.SetStateAction<string>>,
  setSkillIdForm: React.Dispatch<React.SetStateAction<string>>,
  setTabIdForm: React.Dispatch<React.SetStateAction<string>>,
  signOut: () => void
) => {
  setLoadingButtonCreate(true);

  if (payload === "") {
    displayWarning("Preencha a area com o payload");
    setLoadingButtonCreate(false);
    return;
  }

  if (nameForm === "") {
    displayWarning("Preencha o nome do formulário!");
    setLoadingButtonCreate(false);
    return;
  }

  if (skillIdForm === "") {
    displayWarning("Preencha a habilidade!");
    setLoadingButtonCreate(false);
    return;
  }

  if (tabIdForm === "") {
    displayWarning("Preencha a tabulação!");
    setLoadingButtonCreate(false);
    return;
  }

  await getSkillId(skillIdForm, authorization, ambient, setSkillName, signOut);
  await getTabId(tabIdForm, authorization, ambient, setTabName, signOut);

  try {
    const apiClientCreateTemplate = SetupNotAuth();
    const {
      data: { data },
    } = await apiClientCreateTemplate.post(
      `/create-form-by-payload?name=${nameForm}&skillId=${skillIdForm}&tabId=${tabIdForm}&id=${idForm ? idForm : ""
      }`,
      JSON.parse(payload),
      {
        maxBodyLength: Infinity,
      }
    );

    const apiClient = SetupFlow(authorizationRA);
    const {
      data: {
        form: { id },
      },
    } = await apiClient.put(`/update-form?ambient=${ambient}`, data, {
      maxBodyLength: Infinity,
    });

    await apiClient.post(`/publish-form?formId=${id}&ambient=${ambient}`);

    setIdForm("");
    setSkillIdForm("");
    setTabIdForm("");
    setNameForm("");
    setForms("");

    setLoadingButtonCreate(false);
    displaySuccess("Formulário criado!");
  } catch (error: any) {
    displayError("Erro ao salvar o formulário!");
    return;
  }
};
